// This file is generated by the Webpack next-flight-loader.
import { registerClientReference } from "react-server-dom-webpack/server";
export const WorkflowYAMLEditor = registerClientReference(
function() { throw new Error("Attempted to call WorkflowYAMLEditor() from the server but WorkflowYAMLEditor is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
"/app/shared/ui/WorkflowYAMLEditor/ui/WorkflowYAMLEditor.tsx",
"WorkflowYAMLEditor",
);